import type { MerchantCountry } from "~/lib/types";

export type MerchantVerification = "verified" | "pending" | "unverified";

/** Map a merchant's status/approval codes to a display verification state. */
export const getMerchantVerification = (
  m: Record<string, unknown>,
): MerchantVerification => {
  const approval = m.merchant_approval_status_code;
  const status = m.merchant_status_code;
  if (approval === "APPROVED" && status === "ACTIVE") return "verified";
  if (approval === "PENDING") return "pending";
  return "unverified";
};

/** Primary (or first) country code for a merchant, from the countries table. */
export const primaryCountryCode = (
  merchantId: string,
  countries: MerchantCountry[],
): string | null => {
  const forMerchant = countries.filter(c => c.merchant_id === merchantId);
  const primary = forMerchant.find(c => c.merchant_primary_country);
  return (primary ?? forMerchant[0])?.merchant_country_code ?? null;
};

/** Count of active services offered per merchant, keyed by merchant id. */
export const serviceCountByMerchant = (
  merchantItems: { merchant_id: string; item_id: string }[],
): Record<string, number> => {
  const byMerchant = new Map<string, Set<string>>();
  for (const mi of merchantItems) {
    const set = byMerchant.get(mi.merchant_id) ?? new Set<string>();
    set.add(mi.item_id);
    byMerchant.set(mi.merchant_id, set);
  }
  return Object.fromEntries(
    [...byMerchant.entries()].map(([id, set]) => [id, set.size]),
  );
};
